import { utils, writeFileXLSX } from 'xlsx';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// Función para obtener imagen Base64 para el logo del PDF (copiada de useTableExport)
export const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            var dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
        };
        img.onerror = error => {
            reject(error);
        };
        img.src = url;
    });
};

export function useGradesExport() {
    
    const exportGradesData = async ({ ext, data, columns, metadata }) => {
        const expItems = data;
        const expFields = columns.filter(col => !col.noexport && col.key !== 'actions' && col.key !== 'index');

        const getFieldValue = (client, field) => {
            if (field.key === 'alumno') {
                return (client.apellidos || '') + ' ' + (client.nombres || '').trim();
            }
            let val = client[field.key];
            return val !== null && val !== undefined && val !== '' ? val : '-';
        };

        if (ext === 'xlsx') {
            const dataExport = [];
            expItems.forEach((client, index) => {
                dataExport[index] = {};
                dataExport[index]['#'] = index + 1;
                expFields.forEach(field => {
                    dataExport[index][field.label || field.key] = getFieldValue(client, field);
                });
            });

            // Prepare header metadata as Array of Arrays
            const headerData = [
                ['REPORTE DE CALIFICACIONES - ' + (metadata.titulo || '').toUpperCase()],
                [], // Empty row
                ['CURSO:', metadata.curso || '-', 'GRADO/AÑO:', metadata.grado || '-', 'SECCIÓN:', metadata.seccion || '-'],
                ['PROFESOR(A):', metadata.profesor || '-', 'NIVEL:', metadata.nivel || '-', '', ''],
                []  // Empty row before the table headers
            ];

            const ws = utils.aoa_to_sheet(headerData);
            
            // Add the table data starting at row 6 (A6)
            utils.sheet_add_json(ws, dataExport, { origin: "A6" });

            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, 'Calificaciones');
            
            let safeTitle = metadata.titulo ? metadata.titulo.replace(/ /g, '_') : 'Bimestre';
            writeFileXLSX(wb, `Reporte_Calificaciones_${safeTitle}.xlsx`);

        } else if (ext === 'pdf') {
            try {
                pdfMake.vfs = pdfFonts.pdfMake.vfs;

                const makeVertical = (str) => {
                    if (!str) return '';
                    return str.toUpperCase().split('').join('\n');
                };

                // Preparar cabeceras de la tabla
                let dataExport = [];
                let headers = [{ text: 'N°', bold: true, alignment: 'center', margin: [0, 5, 0, 5] }];
                
                expFields.forEach(field => {
                    if (field.key === 'alumno') {
                        headers.push({ text: 'APELLIDOS Y NOMBRES', bold: true, alignment: 'center', margin: [0, 5, 0, 5] });
                    } else {
                        // Textos verticales para las notas
                        headers.push({ 
                            text: makeVertical(field.title || field.label || field.key), 
                            bold: true, 
                            alignment: 'center',
                            fontSize: 7,
                            margin: [0, 5, 0, 5]
                        });
                    }
                });
                
                dataExport.push(headers);

                // Llenar datos
                expItems.forEach((client, index) => {
                    let row = [{ text: (index + 1).toString(), alignment: 'center' }];
                    expFields.forEach(field => {
                        let val = getFieldValue(client, field);
                        if (val === undefined || val === null) val = '-';
                        if (typeof val !== 'string' && typeof val !== 'number') val = String(val);
                        
                        row.push({ 
                            text: val, 
                            alignment: field.key !== 'alumno' ? 'center' : 'left',
                            fontSize: field.key !== 'alumno' ? 9 : 8
                        });
                    });
                    dataExport.push(row);
                });

                // Calculo de anchos
                let colWith = ['auto', '*']; // Num y Alumno
                for (let i = 1; i < expFields.length; i++) {
                    colWith.push(15); // Columnas estrechas para las notas
                }

                const nowDate = new Date();
                const fechaHoy = nowDate.toLocaleDateString('es-ES');

                let logoImage = null;
                try {
                    logoImage = await getBase64ImageFromURL("/documents/mycompany/logos/logomembrete.png");
                } catch (e) {
                    console.warn("Logo no encontrado");
                }

                let headerColumns = [];
                if (logoImage) {
                    headerColumns.push({
                        margin: [40, 10, 0, 0],
                        image: logoImage,
                        width: 40
                    });
                }
                
                headerColumns.push({
                    text: '\nREPORTE DE CALIFICACIONES - ' + (metadata.titulo || ''),
                    style: 'header',
                    alignment: 'center',
                    margin: [-40, 15, 0, 0]
                });

                // Crear Documento
                var docDefinition = {
                    pageSize: 'A4',
                    pageOrientation: 'portrait',
                    pageMargins: [30, 70, 30, 40],
                    header: {
                        columns: headerColumns
                    },
                    footer: function (currentPage, pageCount) { 
                        return [{ text: 'Fecha de consulta: ' + fechaHoy + ' - Pág. ' + currentPage.toString() + ' de ' + pageCount, alignment: 'right', margin: [0, 0, 40, 0], fontSize: 8 }]; 
                    },
                    content: [
                        // Tabla superior de Metadatos
                        {
                            table: {
                                widths: ['15%', '35%', '15%', '15%', '12%', '8%'],
                                body: [
                                    [
                                        { text: 'CURSO:', bold: true, fontSize: 9, fillColor: '#f3f4f6' }, 
                                        { text: metadata.curso || '-', fontSize: 9 }, 
                                        { text: 'GRADO/AÑO:', bold: true, fontSize: 9, fillColor: '#f3f4f6' }, 
                                        { text: metadata.grado || '-', fontSize: 9 }, 
                                        { text: 'SECCIÓN:', bold: true, fontSize: 9, fillColor: '#f3f4f6' }, 
                                        { text: metadata.seccion || '-', fontSize: 9 }
                                    ],
                                    [
                                        { text: 'PROFESOR(A):', bold: true, fontSize: 9, fillColor: '#f3f4f6' }, 
                                        { text: metadata.profesor || '-', fontSize: 9 }, 
                                        { text: 'NIVEL:', bold: true, fontSize: 9, fillColor: '#f3f4f6' }, 
                                        { text: metadata.nivel || '-', fontSize: 9, colSpan: 3 }, 
                                        {}, 
                                        {}
                                    ]
                                ]
                            },
                            layout: {
                                hLineWidth: function (i, node) { return 1; },
                                vLineWidth: function (i, node) { return 1; },
                                hLineColor: function (i, node) { return '#e5e7eb'; },
                                vLineColor: function (i, node) { return '#e5e7eb'; },
                                paddingLeft: function(i, node) { return 4; },
                                paddingRight: function(i, node) { return 4; },
                                paddingTop: function(i, node) { return 3; },
                                paddingBottom: function(i, node) { return 3; }
                            },
                            margin: [0, 0, 0, 15] // Espacio debajo de la cabecera
                        },
                        // Tabla de Calificaciones
                        {
                            table: {
                                headerRows: 1,
                                widths: colWith,
                                body: dataExport
                            },
                            layout: {
                                hLineWidth: function (i, node) { return 1; },
                                vLineWidth: function (i, node) { return 1; },
                                hLineColor: function (i, node) { return '#cbd5e1'; },
                                vLineColor: function (i, node) { return '#cbd5e1'; }
                            }
                        }
                    ],
                    styles: {
                        header: {
                            fontSize: 12,
                            bold: true
                        }
                    },
                    defaultStyle: {
                        fontSize: 9,
                        bold: false
                    }
                };

                pdfMake.createPdf(docDefinition).download('Registro_Calificaciones_' + (metadata.titulo || 'Bimestre') + '.pdf');
            } catch (error) {
                console.error("Error crítico generando el documento PDF de Calificaciones:", error);
                alert("Hubo un error interno al generar el Documento PDF: " + error.message);
            }
        }
    };

    return { exportGradesData };
}
